export class ArrayUtils {
    /**
     * Create a range
     * @param start 
     * @param end 
     * @returns A number range
     */
    public static readonly range = (start, end) => Array.from({length: (end - start)}, (v, k) => k + start);
}